<ng-template #blockTemplate let-blockConfig='blockConfig' let-inTab='inTab' let-index='index'>
  @switch (blockConfig.type) {
    @case ("list") {
      <dataset-list
        #listBlocks
        [showTitle]='enableBlocks.length > 1'
        [autoFetchData]='true'
        [datasetCode]='blockConfig.datasetCode'
        [filters]='blockFilters[index]'
        [parentDatasetRS]='blockDatasetRecordServices[index] || datasetRS'
        [parentDatasetACS]='blockDatasetActionContainerServices[index] || datasetACS'
        [conditionalShowPaginationToolbar]='true'
        [showSearchBar]='false'
        [elevate]='false'
        [showTitle]='!inTab'
        (created)='onCreatedInBlock(blockConfig)'
        (datasetEvent)='onDatasetEvent($event)'
      ></dataset-list>
    }
    @case ("document_file") {
      <document-file-block
        [title]='!inTab && blockConfig.title'
        [record]='datasetRS.record.value'
        [documentFileKey]='blockConfig.documentFileKey'
        [imageOptions]='blockConfig.imageOptions'
        [type]='"image"'
        [uploadRoute]='blockConfig.uploadRoute'
        [getUploadDataFun]='blockConfig.getUploadData'
        (changed)='datasetRS.reload()'
      ></document-file-block>
    }
    @case ("resource-input") {
      <resource-inputs [data] = datasetRS.record.value.data (changed)='datasetRS.reload()'>
      </resource-inputs>
    }
    @default {
      <div>
        <p>{{'Blocco non configurato' | translate}}: {{blockConfig.type}}</p>
      </div>
    }
  }
</ng-template>

<div class='full-form' [class.full-form-wide]='onlyListBlocks'>

  @if (enableBlocks.length > 1) {
    <mat-tab-group>
      @for (blockConfig of stepConfig.options.blocks; track blockConfig; let i = $index) {
        @if (enableBlocks[i]) {
          <mat-tab>
            <ng-template mat-tab-label>{{blockConfig.title | translate}}</ng-template>
            <ng-template matTabContent>
              <ng-container
                [ngTemplateOutlet]='blockTemplate'
                [ngTemplateOutletContext]='{blockConfig: blockConfig, inTab: true, index: i}'
              ></ng-container>
            </ng-template>
          </mat-tab>
        }
      }
    </mat-tab-group>
  }

  @if (enableBlocks.length === 1) {
    @for (blockConfig of stepConfig.options.blocks; track blockConfig; let i = $index) {
      @if (enableBlocks[i]) {
        <ng-container
          [ngTemplateOutlet]='blockTemplate'
          [ngTemplateOutletContext]='{blockConfig: blockConfig, inTab: false, index: i}'
        ></ng-container>
      }
    }
  }
</div>
